import React, { memo } from 'react';
import styled from 'styled-components';

import MainLayout from '@views/layouts/main-layout';
import Breadcrumb from '@views/components/breadcrumb/Breadcrumb';
import { Block } from '@views/components/block';

const H1 = styled.h1`
  font-size: 17px;
  line-height: 28px;
  margin: 0 0 10px;
  font-weight: 700;
  padding: 5px 0;
  color: #444;
  border-bottom: 2px solid #ddd;
`;

const H3 = styled.h1`
  font-size: 16px;
  font-weight: 700;
`;

const ContactPage = () => {
  return (
    <MainLayout
      breadcrumb={
        <Breadcrumb
          options={[
            {
              active: true,
              name: 'Liên hệ',
            },
          ]}
        />
      }
    >
      <Block isSection className="p-2 p-md-4">
        <H1>Giới thiệu về Văn phòng phẩm FAST</H1>
        <p>
          Văn phòng phẩm FAST là đơn vị chuyên cung cấp văn phòng phẩm như giấy
          in, bút viết, fule hồ sơ, băng keo,.. với chất lượng phục vụ tốt nhất,
          giao hàng nhanh nhất tại TP. HCM. Qúy khách hàng có thể hoàn toàn hài
          lòng về chúng tôi.
        </p>

        <p>
          Quý khách có nhu cầu liên lạc, trao đổi hoặc đóng góp ý kiến, vui lòng
          tham khảo các thông tin sau:
        </p>
        <ul>
          <li>Liên lạc qua điện thoại/zalo: 0964 399 099</li>
          <li>
            Liên lạc qua email:{' '}
            <a href="mailto:vanphongphamfast@gmail.com">
              vanphongphamfast@gmail.com
            </a>
          </li>
          <li>
            Fanpage của FAST:{' '}
            <a href="https://www.facebook.com/vppfast">
              https://www.facebook.com/vppfast
            </a>
          </li>
          <li>Trụ sở: 671/3 Hồng Bàng, Phường 6, Quận 6, TP.HCM</li>
        </ul>

        <H3>Thông tin về công ty</H3>
        <ul>
          <li>CÔNG TY TNHH TM DV FAST</li>
          <li>
          Trụ sở: 1174 Võ Văn Kiệt, Phường 10, Quận 5, TP. HCM </li>
          <li>Địa chỉ kho: 671/3 Hồng Bàng, Phường 6, Quận 6, TP. HCM
          </li>
          <li>
            Giấy chứng nhận Đăng ký Kinh doanh số 0313473195 do Sở Kế hoạch và
            Đầu tư Thành phố Hồ Chí Minh cấp ngày 06/10/2015
          </li>
        </ul>
        <H3>Văn phòng FAST</H3>
        <div style={{ display: 'block', textAlign: 'center' }}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.7582449364186!2d106.64532621553894!3d10.75310616256228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752e8be575c7af%3A0xecfeac390c2720ab!2zNjcxLCA2ODMvMyBI4buTbmcgQsOgbmcsIFBoxrDhu51uZyA2LCBRdeG6rW4gNiwgVGjDoG5oIHBo4buRIEjhu5MgQ2jDrSBNaW5oLCBWaWV0bmFt!5e0!3m2!1sen!2s!4v1651709443475!5m2!1sen!2s" 
            width="600"
            height="450"
            style={{ border: 0, maxWidth: '100%' }}
            allowFullScreen
            loading="lazy"
           referrerPolicy="no-referrer-when-downgrade"/>
          {/* <iframe
            src="//www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.718276886515!2d106.64738821467115!3d10.756181992335309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752e8ec84ea6e7%3A0x8f1ebeef090ea3d2!2sStationery%20FAST!5e0!3m2!1sen!2s!4v1625927529855!5m2!1sen!2s"
            width="600"
            height="450"
            style={{ border: 0, maxWidth: '100%' }}
            allowFullScreen
            loading="lazy"
          /> */}
        </div>
      </Block>
    </MainLayout>
  );
};

const Wrapper = memo(ContactPage);
Wrapper.displayName = 'ContactPage';

export default Wrapper;
